import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import DeleteModal from 'modules/reports/components/DeleteModal'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const DashboardDeleteModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { dashboard } = useOutletContext<RouteContextParams>()

  return dashboard ? (
    <DeleteModal
      dashboard={dashboard}
      onClose={() =>
        navigate(
          navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: dashboard.id })
        )
      }
      onSuccess={() => navigate(navigation.reports.dashboards.list.fullPath())}
    />
  ) : null
}

export default DashboardDeleteModalPage
